import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "../../../../groups/VisibilityGroup";
import EmptyUnit from "../../../unit/EmptyUnit";

class MetricWinOtherSuppliers extends MetricBase {
    constructor() {
        super({
            field: "metric_win_other_supplier",
            defaultVisibility: false,
            unit: new EmptyUnit(),
           /* chartName: i18n.t("metrics.tripadvisor.spent.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.spent.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.spent.tooltip"), */
            group: new VisibilityGroup(),
        });
    }
}

export default MetricWinOtherSuppliers;